import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MxIpService {
  constructor(private http: HttpClient) {}

  public getIPAddress(): Observable<{ ip: string }> {
    return of({ ip: '0.0.0.0' });
    // return this.http.get<{ ip: string }>('https://api.ipify.org/?format=json');
  }
}
